import { useIndexedDb } from '../../../common/hooks/useIndexedDb';

export const useIdbToken = () => useIndexedDb<string>('token');
